/* eslint-disable import/no-duplicates */
import type { Locale } from 'date-fns';
import cs from 'date-fns/locale/cs/index.js';
import de from 'date-fns/locale/de/index.js';
import enUS from 'date-fns/locale/en-US/index.js';
import es from 'date-fns/locale/es/index.js';
import fr from 'date-fns/locale/fr/index.js';
import it from 'date-fns/locale/it/index.js';
import nlBE from 'date-fns/locale/nl-BE/index.js';
import pl from 'date-fns/locale/pl/index.js';
import pt from 'date-fns/locale/pt/index.js';

// Isolated date-fns locale map so date helpers can import it without pulling
// the heavy `@app/constants` barrel (antd locales / React) into their graph.
export const locales: { [key: string]: Locale } = {
  us: enUS,
  nl: nlBE,
  fr,
  de,
  cs,
  es,
  it,
  pl,
  pt,
};
